import { call, put, takeEvery } from "redux-saga/effects";
import { AVLPageContainerActionTypes } from "./types";
import Traccar from "../../api/REST/Traccar/Traccar";
export const avlPageContainerSagas = {
    initSaga: takeEvery(AVLPageContainerActionTypes.INIT, initSaga),
};
function* initSaga(action) {
    yield call(Traccar.authenticate);
    yield put({
        type: AVLPageContainerActionTypes.SET_CONNECTION_INFO,
        host: window.location.hostname
    });
}
function getAVLPageContainerStateSelector(store) {
    return store.avl;
}
export default avlPageContainerSagas;
